import { gql } from '@apollo/client';

export const UPDATE_ALERT_STATUS = gql`
  mutation UpdateAlertStatus($data: UpdateCriterionAlertInput!) {
    updateCriterionAlertStatus(data: $data) {
      alertId
    }
  }
`;
